package team.platforma.multiplatform_material_extension.scrollbar.style

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonElevation
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shadow
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.util.IndicatorPadding

object ScrollIndicatorStyle {
    private var _color: Color? = null
    private var _elevation: Dp = 2.dp
    private var _shape: Shape = RoundedCornerShape(100)
    private var _indicatorMinSize: Dp = 80.dp
    private var _indicatorPadding: Dp = 8.dp
    @Composable
    fun define(
        color: Color = MaterialTheme.colorScheme.tertiary,
        elevation: Dp = 2.dp,
        shape: Shape = RoundedCornerShape(100),
        indicatorMinSize: Dp = 80.dp,
        indicatorPadding: Dp = 8.dp
    ) {
        _color = color
        _elevation = elevation
        _shape = shape
        _indicatorMinSize = indicatorMinSize
        _indicatorPadding = indicatorPadding
    }

    @Composable
    internal fun getColor(): Color {
        return _color ?: MaterialTheme.colorScheme.tertiary
    }

    internal fun getElevation(): Dp {
        return _elevation
    }

    internal fun getShape(): Shape {
        return _shape
    }

    internal fun indicatorMinSize() : Dp {
        return _indicatorMinSize
    }

    internal fun indicatorPadding() : Dp {
        return _indicatorPadding
    }

}